var _path, _path2, _path3, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrashSizeDefault = function SvgTrashSizeDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13C11.5 12.7239 11.2761 12.5 11 12.5C10.7239 12.5 10.5 12.7239 10.5 13H11.5ZM21.5 13C21.5 12.7239 21.2761 12.5 21 12.5C20.7239 12.5 20.5 12.7239 20.5 13H21.5ZM20.5 13V23H21.5V13H20.5ZM20 23.5H12V24.5H20V23.5ZM11.5 23V13H10.5V23H11.5ZM12 23.5C11.7239 23.5 11.5 23.2761 11.5 23H10.5C10.5 23.8284 11.1716 24.5 12 24.5V23.5ZM20.5 23C20.5 23.2761 20.2761 23.5 20 23.5V24.5C20.8284 24.5 21.5 23.8284 21.5 23H20.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14V21M18 14V21",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C17.5 10.2761 17.7239 10.5 18 10.5C18.2761 10.5 18.5 10.2761 18.5 10H17.5ZM13.5 10C13.5 10.2761 13.7239 10.5 14 10.5C14.2761 10.5 14.5 10.2761 14.5 10H13.5ZM15 8.5H17V7.5H15V8.5ZM17.5 9V10H18.5V9H17.5ZM14.5 10V9H13.5V10H14.5ZM17 8.5C17.2761 8.5 17.5 8.72386 17.5 9H18.5C18.5 8.17157 17.8284 7.5 17 7.5V8.5ZM15 7.5C14.1716 7.5 13.5 8.17157 13.5 9H14.5C14.5 8.72386 14.7239 8.5 15 8.5V7.5Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 11.5,
    x2: 23.5,
    y2: 11.5,
    stroke: "black",
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashSizeDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-size-default.27d8dc3c.svg";
export { ForwardRef as ReactComponent };